import Dignitary from "../components/Dignitary";
import { useContext, useEffect } from "react";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { mediaSource } from "../utilities/mediautilities";
import Breadcrumb from "../components/Breadcrumb.jsx";
import { setBrowserTitle } from "../utilities/codes.js";

const Dignitaries = () => {
    const { schoolDetails } = useContext(schoolContext);

    useEffect(() => {
        setBrowserTitle("Dignitaries")
    }, [])

    return (
        <>
            <section className="relative bg-cover bg-center py-36 px-6">
                <img
                    src={mediaSource(schoolDetails?.dignataries?.fileUrl)}
                    alt={"Page banner"}
                    className="absolute inset-0 w-full h-full object-cover"
                />
            </section>
            <Breadcrumb />
            <Dignitary />
        </>
    );
}
export default Dignitaries;